import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web';

  constructor(private router:Router, private cookieService:CookieService){

  }

  ngOnInit(): void {
    if(this.cookieService.get('hide-how-it-works') !== "true" && !document.location.href.includes('meld-storing')){
      this.router.navigateByUrl('hoe-werkt-het/intro') 
    }
  }

}
